import { QUERY_KEY_STORIES } from '~/widgets/Stories'
import { debtModel } from '~/entities/Debt'
import { driverModel } from '~/entities/Driver'
import { mainBalance } from '~/entities/MainBalance'
import { rentalContractModel } from '~/entities/RentalContract'
import { rentalServiceModel } from '~/entities/RentalService'
import { useRefreshList } from '~/shared/ui/ScrollableList'

export const useRefreshPage = () => {
  const { refreshList } = useRefreshList(QUERY_KEY_STORIES)

  const refreshPage = async () => {
    await Promise.all([
      driverModel.getDriverFx(),
      mainBalance.getCurrentBalanceSilentFx(),
      mainBalance.getCurrentBalanceReportSilentFx(),
      mainBalance.getAllBalancesSilentFx(),
      rentalContractModel.getRentalContractSilentFx(),
      rentalServiceModel.getRentalServicesSilentFx(),
      debtModel.getReportSilentFx(),
      refreshList(),
    ])
  }

  return { refreshPage }
}
